import React, { useState, useEffect, useCallback } from 'react'
import ReactModal from 'react-modal'

import { isFunction } from '../lib/utils'
import { DEFAULT_ANIMATION } from '../lib/const'

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '9999999',
    inset: 0,
  },
  content: {
    width: '25%',
    maxWidth: '400px',
    height: 'fit-content',
    overflow: 'visible',
    transform: 'translate(-50%, -50%)',
    top: '50%',
    left: '50%',
    position: 'absolute',
    border: '1px solid #ccc',
    background: '#fff',
    borderRadius: '10px',
    padding: '20px',
    boxSizing: 'border-box',
    display: 'block',
  },
}

export default () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    ReactModal.setAppElement('body')
  }, [])

  const Modal = ({ handleCloseModal, onContinue, title, description, icon: Icon }) => {
    const onCloseModal = useCallback(() => {
      setIsOpen(false)
      isFunction(handleCloseModal) && handleCloseModal()
    }, [handleCloseModal])

    return (
      <ReactModal isOpen={isOpen} onRequestClose={onCloseModal} style={customStyles}>
        <div
          style={{
            width: '100%',
            textAlign: 'center',
          }}
        >
          {/* {Icon && (
            <div style={{ marginBottom: '20px',height:'20px',width:'20px' }}>
              <Icon />
            </div>
          )} */}
          <h4 style={{ marginBottom: '10px', fontSize: '1.5em', fontWeight: 'bold' }}>{title}</h4>
          <p style={{ marginBottom: '20px', fontSize: '1em', color: '#555' }}>{description}</p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '20px',
              width: '100%',
              maxWidth: '400px',
              margin: '0 auto',
            }}
          >
            <button
              type="button"
              onClick={onCloseModal}
              style={{
                padding: '10px 20px',
                background: '#f0f0f0',
                border: '1px solid #ccc',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '1em',
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onContinue}
              style={{
                padding: '10px 20px',
                background: '#d9534f',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '1em',
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </ReactModal>
    );
  };

  return { Modal, setIsOpen };
};
